import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { defineComponent as _defineComponent } from 'vue';
import { useRoute } from '@nuxtjs/composition-api';
import { storeToRefs } from 'pinia';
import { PortalTarget } from 'portal-vue';
import { computed, defineComponent, onMounted, provide, ref } from 'vue';
import { TheContextMenu, TheModal, TheModalIframe } from '@/app/overlay-orchestrator';
import { AcceptCookies } from '@/features/cookies-consent/ui';
import { ModalAcceptedLegalDocuments } from '@/features/legal-documents-modal';
import ModalSelectSaleCity from '@/features/onboarding/ui/ModalSelectSaleCity.vue';
import { usePortalApi } from '@/plugins/api/portal';
import { useVuexStore } from '@/plugins/app-context';
import { useScreenPlugin } from '@/plugins/vue-screen';
import { useLegalDocuments } from '@/shared/composables';
import { iosScrollShouldLockAttributeName, LEGAL_DOCUMENTS_ACCEPTED } from '@/shared/constants';
import { BackdropOverlay, ScrollUpButton } from '@/shared/ui';
import { useAuthStore } from '@/store/authStore';
import { useLegalDocumentsStore } from '@/store/documents';
import { useFeatureFlagsStore } from '@/store/featureFlags';
import { useWarningsStore } from '@/store/warning';
import { AppFooter } from '@/widgets/Footer';
import { AppHeader, HeaderNotificationsButton } from '@/widgets/Header';
import { AppMenu } from '@/widgets/Menu';
import { useMenuLogic } from '@/widgets/Menu/model';
import { MenuDesktopActivator } from '@/widgets/Menu/ui';
import { NotificationsContainer } from '@/widgets/Notifications';
export default /*#__PURE__*/_defineComponent({
  __name: 'Layout',
  props: {
    hasFooter: {
      type: Boolean,
      default: false
    }
  },
  setup: function setup(__props) {
    // если просто импортировать, то он почему-то не видит в разметке эту константу
    var iosScrollShouldLockAttributeNameCrutch = iosScrollShouldLockAttributeName;
    defineComponent({
      name: 'Layout'
    });
    var route = useRoute();
    var screen = useScreenPlugin();
    var menuRef = ref(null);
    var menuLogic = useMenuLogic(menuRef);
    var menuVisible = menuLogic.menuVisible;
    function onMenuItemClick() {
      if (screen.isMobileOrTablet) {
        menuLogic.close();
      }
    }
    var backdropVisible = computed(function () {
      return screen.isMobileOrTablet && menuVisible.value;
    });
    provide('$portalApi', usePortalApi());
    provide('$screen', screen);
    var isLogin = computed(function () {
      return useVuexStore().state.auth.loggedIn;
    });
    var isFired = computed(function () {
      return useVuexStore().state.auth.user.isFired;
    });
    // -- legal documents start --
    var legalDocumentsStore = useLegalDocumentsStore();
    var _useLegalDocuments = useLegalDocuments(),
      acceptedLegalDocuments = _useLegalDocuments.acceptedLegalDocuments,
      acceptedLegalDocumentsV2 = _useLegalDocuments.acceptedLegalDocumentsV2,
      documentsSlugsWithRole = _useLegalDocuments.documentsSlugsWithRole;
    var loadAcceptedLegalDocuments = legalDocumentsStore.loadAcceptedLegalDocuments,
      loadAcceptedLegalDocumentsV2 = legalDocumentsStore.loadAcceptedLegalDocumentsV2;
    var _useFeatureFlagsStore = useFeatureFlagsStore(),
      isAcceptPrivateFlag = _useFeatureFlagsStore.isAcceptPrivateFlag;
    /**
     * Общие условия отображения
     */
    var isShowLegalDocumentsAccept = computed(function () {
      var _route$value$name;
      if (!isLogin.value) {
        return false;
      }
      return !(route !== null && route !== void 0 && (_route$value$name = route.value.name) !== null && _route$value$name !== void 0 && _route$value$name.includes('legal-documents'));
    });
    var isShowModalAcceptedLegalDocuments = computed(function () {
      var acceptedDocuments = isAcceptPrivateFlag() ? acceptedLegalDocumentsV2() : acceptedLegalDocuments(documentsSlugsWithRole());
      return acceptedDocuments.length && isShowLegalDocumentsAccept.value;
    });
    var isShowCookies = computed(function () {
      if (isShowModalAcceptedLegalDocuments.value) {
        return false;
      }
      var slugsDocuments = LEGAL_DOCUMENTS_ACCEPTED.cookies;
      var acceptedDocuments = acceptedLegalDocuments(slugsDocuments);
      return acceptedDocuments.length && isShowLegalDocumentsAccept.value;
    });
    // -- legal documents end --
    var isShowScrollButton = computed(function () {
      var routeName = useRoute().value.name;
      var query = useRoute().value.query;
      // не отображаем кнопку скролл вверх на странице закрытые продажи
      if (routeName === 'closed-sales') {
        return false;
      }
      // не отображаем кнопку скролл вверх на шахматке в мобиле
      var isChessboard = routeName === 'choice-apartment-chessboard-project' && (query === null || query === void 0 ? void 0 : query.building) && screen.isMobileOrTablet;
      return !isChessboard;
    });
    var authStore = useAuthStore();
    var userAuthed = computed(function () {
      return Boolean(authStore.user);
    });
    var hasCityOfSale = computed(function () {
      var _authStore$user;
      return ((_authStore$user = authStore.user) === null || _authStore$user === void 0 ? void 0 : _authStore$user.city_of_sale) != null;
    });
    var warningsStore = useWarningsStore();
    var _storeToRefs = storeToRefs(warningsStore),
      warnings = _storeToRefs.warnings;
    var getWarnings = warningsStore.getWarnings,
      removeWarning = warningsStore.removeWarning;
    var requests = [getWarnings()];
    if (isAcceptPrivateFlag()) {
      requests.push(loadAcceptedLegalDocumentsV2(), loadAcceptedLegalDocuments(LEGAL_DOCUMENTS_ACCEPTED.cookies));
    } else {
      requests.push(loadAcceptedLegalDocuments(documentsSlugsWithRole(true)));
    }
    onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 1;
            return Promise.all(requests);
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    return {
      __sfc: true,
      iosScrollShouldLockAttributeNameCrutch: iosScrollShouldLockAttributeNameCrutch,
      route: route,
      screen: screen,
      menuRef: menuRef,
      menuLogic: menuLogic,
      menuVisible: menuVisible,
      onMenuItemClick: onMenuItemClick,
      backdropVisible: backdropVisible,
      isLogin: isLogin,
      isFired: isFired,
      legalDocumentsStore: legalDocumentsStore,
      acceptedLegalDocuments: acceptedLegalDocuments,
      acceptedLegalDocumentsV2: acceptedLegalDocumentsV2,
      documentsSlugsWithRole: documentsSlugsWithRole,
      loadAcceptedLegalDocuments: loadAcceptedLegalDocuments,
      loadAcceptedLegalDocumentsV2: loadAcceptedLegalDocumentsV2,
      isAcceptPrivateFlag: isAcceptPrivateFlag,
      isShowLegalDocumentsAccept: isShowLegalDocumentsAccept,
      isShowModalAcceptedLegalDocuments: isShowModalAcceptedLegalDocuments,
      isShowCookies: isShowCookies,
      isShowScrollButton: isShowScrollButton,
      authStore: authStore,
      userAuthed: userAuthed,
      hasCityOfSale: hasCityOfSale,
      warningsStore: warningsStore,
      warnings: warnings,
      getWarnings: getWarnings,
      removeWarning: removeWarning,
      requests: requests,
      PortalTarget: PortalTarget,
      TheContextMenu: TheContextMenu,
      TheModal: TheModal,
      TheModalIframe: TheModalIframe,
      AcceptCookies: AcceptCookies,
      ModalAcceptedLegalDocuments: ModalAcceptedLegalDocuments,
      ModalSelectSaleCity: ModalSelectSaleCity,
      BackdropOverlay: BackdropOverlay,
      ScrollUpButton: ScrollUpButton,
      AppFooter: AppFooter,
      AppHeader: AppHeader,
      HeaderNotificationsButton: HeaderNotificationsButton,
      AppMenu: AppMenu,
      MenuDesktopActivator: MenuDesktopActivator,
      NotificationsContainer: NotificationsContainer
    };
  }
});